import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { DeleteAmeRule, GetAmeRuleListByDynamicFormId } from '../../../../store/Ame/ameRuleSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import NeatixModal from '../../../../components/Modal/NeatixModal';
import AddAmeConditionUsage from '../AmeConditionUsage/AddAmeConditionUsage';
import AddAmeAction from '../AmeActionRule/AddAmeAction';

function AmeRuleList({ data }) {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [rule, setRule] = useState();

  const { HasPermission } = usePermissions();
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const Navigate = useNavigate();

  // Handele Delete AmeCondition
  const handleDeleteAmeRule = (item) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeleteAmeRule(item.id))
        .unwrap()
        .then(() => {
          dispatch(GetAmeRuleListByDynamicFormId(id));
          CustomAlert({ action: 'Delete' });
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  // console.log(rule);
  const location = useLocation();
  const { ReferenceName } = location.state;

  const titleModal = () => {
    return (
      <div className="fs-5">
        {t('RuleConditions')}
        {'  '}
        <span className="text-theme">
          {`"${i18n.language === 'en' ? rule?.name : rule?.name2}"`}
        </span>
        <span className="text-theme">{` - (${ReferenceName})`}</span>
      </div>
    );
  };

  const titleModal2 = () => {
    return (
      <div className="fs-5">
        {t('ApprovalGroup')}
        {'  '}
        <span className="text-theme">
          {`"${i18n.language === 'en' ? rule?.name : rule?.name2}"`}
        </span>
        <span className="text-theme">{` - (${ReferenceName})`}</span>
      </div>
    );
  };

  return (
    <>
      <div className="table-responsive rounded-2 text-center  ">
        <table className="table table-hover text-nowrap mb-0">
          <thead className="bg-theme bg-opacity-60">
            <tr>
              <th scope="col">{t('#')}</th>
              <th scope="col">{t('Name')}</th>
              <th scope="col"></th>
            </tr>
          </thead>

          <tbody>
            {data?.map((item, idx) => (
              <tr key={item.id}>
                <td className="align-middle">{++idx}</td>
                <td className="align-middle">{i18n.language === 'ar' ? item.name2 : item.name}</td>
                <td className="align-middle text-end">
                  <div className="btn-group">
                    {HasPermission('AmeRuleConditions') && (
                      <button
                        // onClick={() => Navigate(`${item.id}/AddAmeConditionUsage`)}
                        onClick={() => {
                          setRule(item);
                          setShow(true);
                        }}
                        type="button"
                        className="btn btn-outline-theme mx-1">
                        <i className="fas fa-lg fa-fw me-2 fa-question"></i>
                        {t('RuleConditions')}
                      </button>
                    )}

                    {HasPermission('AmeSetRuleApprovals') && (
                      <button
                        // onClick={() => Navigate(`${item.id}/AddAmeAction`)}
                        onClick={() => {
                          setRule(item);
                          setShow2(true);
                        }}
                        type="button"
                        className="btn btn-outline-theme mx-1">
                        <i className="fas fa-lg fa-fw me-2 fa-list-ol"></i>
                        {t('ApprovalGroup')}
                      </button>
                    )}
                  </div>
                  {HasPermission('AmeDeleteRule') && (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-danger mx-1 "
                        onClick={() => handleDeleteAmeRule(item)}>
                        <i className="fas fa-trash-alt fa-fw fa-lg"></i>
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <NeatixModal show={show} setShow={setShow} title={titleModal()} size="lg">
        {rule && <AddAmeConditionUsage ruleId={rule.id} onclose={() => setShow(false)} />}
      </NeatixModal>

      <NeatixModal show={show2} setShow={setShow2} title={titleModal2()} size="lg">
        {rule && <AddAmeAction ruleId={rule.id} onclose={() => setShow2(false)} />}
      </NeatixModal>
    </>
  );
}

export default AmeRuleList;
